module.exports = __webpack_public_path__ + "static/media/logo_high_resolution_white.3c28866b.png";